import React, { Fragment } from 'react'
import { Carousel, } from 'antd'
import { ArrowRightOutlined } from '@ant-design/icons';
import moment from 'moment'
import './style.css'
import { Link } from 'react-router-dom';
export default function NewsRecommend(props) {
    const { data, news } = props;
    return (
        <div className='NewsRecommend'>
            {/* <img className='NewsRecommend_Background' src='images/HomePage/NewsRecommend/3.png' /> */}
            <div className='NewsRecommendMain'>
                <div className='NewsRecommend_LittleCard'>
                    <div className='NewsRecommend_LittleCardBackground' />
                    <div className='NewsRecommend_LittleCardTitle'>
                        <div className='NewsRecommend_LittleCardTitleBorder' />
                        <div className='NewsRecommend_LittleCardTitleText'>新闻推荐</div>
                    </div>
                </div>
                {news.map((item) => {
                    return <NewsRecommendCard data={item} />
                })}
                <div className='NewsRecommend_LittleCard'>
                    <div className='NewsRecommend_LittleCardBackground' />
                    <Link to='/NewsBulletin'>
                        <div className='NewsRecommend_LittleCardButton'>
                            <div className='NewsRecommend_LittleCardButtonText' >更多</div>
                            <img className='NewsRecommend_LittleCardButtonImg' src='images/HomePage/NewsRecommend/more.png' />
                        </div>
                    </Link>
                </div>
            </div>
        </div>
    )
}

const NewsRecommendCard = (props) => {
    const { data } = props;
    return (
        <div className='NewsRecommendCard'>
            {/* <img className='NewsRecommendCard_Img' src={data.img} /> */}
            <div className='NewsRecommendCard_Img' style={{ backgroundImage: `linear-gradient(0deg, rgba(0, 114, 229, 0.2), rgba(0, 114, 229, 0.2)), linear-gradient(0deg, rgba(0, 114, 229, 0.2), rgba(0, 114, 229, 0.2)), linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${data.thumbnail})` }} />
            <div className='NewsRecommendCardMain'>
                <div className='NewsRecommendCard_Title' title={data.title}>{data.title}</div>
                <div className='NewsRecommendCard_Introduce'>{data.summary}</div>
                <div className='NewsRecommendCard_Time'>{moment(data.created).format('YYYY-MM-DD HH:mm:ss')}</div>
            </div>
        </div>
    )
}

// const NewsRecommendCard = (props) => {
//     const { data } = props;
//     return (
//         <div className='NewsRecommendCard'>
//             {/* <img className='NewsRecommendCard_Img' src={data.img} /> */}
//             <div className='NewsRecommendCard_Img' style={{background: `linear-gradient(0deg, rgba(0, 114, 229, 0.2), rgba(0, 114, 229, 0.2)), linear-gradient(0deg, rgba(0, 114, 229, 0.2), rgba(0, 114, 229, 0.2)), linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${data.img})`}}/>
//             <div className='NewsRecommendCardMain'>
//                 <div className='NewsRecommendCard_Title' title={data.title}>{data.title}</div>
//                 <div className='NewsRecommendCard_Introduce'>{data.introduce}</div>
//                 <div className='NewsRecommendCard_Time'>{data.time}</div>
//             </div>
//         </div>
//     )
// }